module.exports = __webpack_public_path__ + "img/div6s.5578bddc.jpg";